<template lang="pug">
.yx-container
    .yx-top
        slot(name="top")
    .yx-main
        slot(name="main")
    .yx-bottom
        slot(name="bottom")
</template>
<script>
import { isIOS } from '@/utils/html-utils.js'

export default {
    mounted() {
        let focusFlag = false
        if (isIOS) {
            // 解决一个很坑的原生浏览器的bug
            document.body.addEventListener(
                'focus',
                function() {
                    focusFlag = true
                },
                true
            )
            // 获取失去焦点时 窗口向上移的bug
            document.body.addEventListener(
                'focusout',
                function() {
                    focusFlag = false
                    setTimeout(() => {
                        if (!focusFlag) {
                            document.body.scrollTop = document.body.scrollHeight
                        }
                    }, 300)
                },
                true
            )
        }
    }
}
</script>
<style lang="scss" scoped>
.yx-container {
    display: flex;
    flex-direction: column;
    background-color: #fff;
    height: 100%;
    overflow: auto;
    -webkit-overflow-scrolling: touch;
    .yx-main {
        overflow: auto;
        -webkit-overflow-scrolling: touch;
        flex: 1;
        height: 100%;
        /*定义滚动条高宽及背景 高宽分别对应横竖滚动条的尺寸*/
        &::-webkit-scrollbar {
            width: 0;
        }
    }
}
</style>
